import { cn } from '@/lib/utils'
import {
  effectiveConfidence,
  confidenceLevel,
  confidenceBgClass,
  type ConfidenceLevel,
} from '@/lib/confidence'

interface ConfidenceBadgeProps {
  confidence: number | null | undefined
  qualityScore?: string | null
  className?: string
}

const levelLabels: Record<ConfidenceLevel, string> = {
  high: 'High',
  medium: 'Med',
  low: 'Low',
  none: 'None',
}

export function ConfidenceBadge({ confidence, qualityScore, className }: ConfidenceBadgeProps) {
  const effective = effectiveConfidence(confidence, qualityScore)
  const level = confidenceLevel(effective)
  const bgClass = confidenceBgClass(level)

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium text-white',
        bgClass,
        className,
      )}
      title={effective != null ? `${(effective * 100).toFixed(0)}%` : 'No match'}
    >
      {levelLabels[level]}
      {effective != null && (
        <span className="ml-1 opacity-80">{(effective * 100).toFixed(0)}%</span>
      )}
    </span>
  )
}
